import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Reveal, Eyebrow } from "../Reveal";
import { api, formatApiError } from "../../lib/api";

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent — we usually reply within two days.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const field = "w-full rounded-xl border border-linen bg-white px-5 py-3.5 text-sm text-ink placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-ember/40 focus:border-ember transition-colors duration-300";

  return (
    <section id="contact" className="py-20 md:py-28 bg-cream-2 border-t border-linen" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal><Eyebrow>04 · Say hello</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-serif font-semibold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-[1.12]" data-testid="contact-heading">
              Questions, stories, partnerships — we're listening.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-stone-600 leading-relaxed max-w-md">
              Want to share your story, suggest a workshop topic, or bring AIWC to your community?
              Write to us — a real person reads every message.
            </p>
            <a href="mailto:aiforwomencommunity@gmail.com" data-testid="contact-email-link"
               className="mt-6 inline-block text-sm font-semibold text-ember hover:text-ember-dark transition-colors duration-300 break-all">
              aiforwomencommunity@gmail.com
            </a>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal delay={0.15}>
            <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input type="text" required placeholder="Your name" value={form.name} data-testid="contact-name-input"
                       onChange={(e) => setForm({ ...form, name: e.target.value })} className={field} />
                <input type="email" required placeholder="Your email" value={form.email} data-testid="contact-email-input"
                       onChange={(e) => setForm({ ...form, email: e.target.value })} className={field} />
              </div>
              <textarea required rows={6} placeholder="Your message" value={form.message} data-testid="contact-message-input"
                        onChange={(e) => setForm({ ...form, message: e.target.value })} className={`${field} resize-none`} />
              <button type="submit" disabled={busy} data-testid="contact-submit-button"
                      className="inline-flex items-center gap-2 rounded-full bg-ink text-cream text-sm font-semibold px-8 py-4 hover:bg-ember transition-colors duration-300 disabled:opacity-60">
                {busy ? "Sending…" : <>Send message <Send size={15} /></>}
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
